<template>
  <!-- La fila de abajo del titulo en las tres pantallas de una contratista
       (sus obligaciones, su personal y sus vehiculos): a la izquierda lo que
       la pantalla ponga en el slot -las notas internas-, a la derecha los
       saltos a las otras dos pantallas. -->
  <div class="contractor-sections">
    <div class="contractor-sections__main">
      <slot></slot>
    </div>
    <div class="contractor-sections__buttons">
      <v-btn
        v-for="section in sections"
        :key="section.name"
        small
        depressed
        color="primary"
        class="ml-2"
        @click="$router.push(`/contractors/${$route.params.id}/${section.name}`)"
      >
        {{ section.label }}
      </v-btn>
    </div>
  </div>
</template>

<script>
"use strict";

export default {
  name: "contractorSections",
  props: {
    // La pantalla en la que se esta: obligations, employees o vehicles.
    current: { type: String, required: true }
  },
  computed: {
    sections() {
      const labels = this.resx.labels;
      return [
        { name: "obligations", label: labels.contractor },
        { name: "employees", label: labels.employees },
        { name: "vehicles", label: labels.vehicles }
      ].filter(section => section.name !== this.current);
    }
  }
};
</script>

<style lang="scss">
// El padding derecho (16px del card-title + 16px de la barra) alinea el borde
// derecho de los botones con el del filtro de arriba. El padding superior de
// los botones salta la etiqueta "Comentarios", asi quedan a la altura de la
// caja y no de su titulo.
.contractor-sections {
  display: flex;
  align-items: flex-start;
  padding-right: 32px;

  &__main {
    flex: 1 1 auto;
    min-width: 0;
  }

  &__buttons {
    display: flex;
    flex: 0 0 auto;
    padding-top: 20px;
  }
}
</style>
